export default __webpack_public_path__ + "static/media/catalogicon.ca3a1350.svg";